const VALID_EMAIL =
    // eslint-disable-next-line security/detect-unsafe-regex
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const validateEmail = value => VALID_EMAIL.test(value);

/**
 * Canonical key for comparing two email addresses.
 *
 * Assignment rows come straight off the API while the user list is run through `formatUser`,
 * which lowercases. Comparing them raw misses a legacy mixed-case assignee. Non-strings pass
 * through so the `null` "unassigned" sentinel keeps its identity.
 *
 * @param {*} value
 * @returns {*} The lowercased address, or `value` unchanged when it is not a string
 */
export const emailKey = value => (typeof value === 'string' ? value.toLowerCase() : value);
